<template>
  <div class="container page-item-container">
    <form class="needs-validation" id="contact-form" @submit.prevent="validateContactForm" data-toggle="validator" novalidate>
      <!-- page-container -->
      <div class="">
        <h3 class="page-title">Contact us</h3>

        <div class="row" v-if="!this.sendSuccessful">
          <div class="col-12 col-lg-8">
            <div><p>Use the form below to get in touch</p></div>
          </div>
        </div>

        <div class="col-12 col-lg-8 clear-padding-left" v-if="this.sendSuccessful">
          <div class="row">
            <p class="">Thank you, your question/comment has been sent.</p>
          </div>
        </div>
        <div class="col-12 col-lg-8 clear-padding-left" v-if="this.submitMessage != null && this.submitMessage.length > 0">
          <div class="alert alert-danger">
            <p class="">{{this.submitMessage}}</p>
            <div v-for="(error, index) in this.submitErrors" :key="index">
              <p>{{error}}</p>
            </div>
          </div>
        </div>

        <div class="row" v-if="!this.sendSuccessful">
          <div class="col-12 col-lg-8">
            <Textbox id="item.firstname" :errors="this.errors" :value="item.firstname" @update="UPDATE_FIELD" label="Firstname" />
            <Textbox id="item.lastname" :errors="this.errors" :value="item.lastname" @update="UPDATE_FIELD" label="Lastname" />
            <Textbox id="item.email" :errors="this.errors" :value="item.email" @update="UPDATE_FIELD" label="Email address" />
            <Textbox id="item.phoneNumber" :errors="this.errors" :value="item.phoneNumber" @update="UPDATE_FIELD" label="Phone number" />
            <Textarea id="item.comment" :errors="this.errors" :value="item.comment" @update="UPDATE_FIELD" label="Questions and comments" />
            </div>
          <div class="col-12 col-lg-8">
            <div class="form-group row">
              <div class="col-12 col-lg-4"></div>
              <div class="col-12  col-lg-7">
                <div class="row">
                  <div class="col-12 col-md-12">
                    <button type="submit" class="btn default-btn-color btn-primary">Send</button>
                  </div>
                  
                </div>
              </div>

            </div>
          </div>

            
      </div>
    </div>
      </form>
  </div>
</template>

<script>
/* eslint-disable */
import { UserService } from "@/services/UserServices/UserService";
import Tooltip from "@/components/controls/Tooltip.vue";
import Textbox from "@/components/controls/Textbox.vue";
import Textarea from "@/components/controls/Textarea.vue";
import rbValidator from "@/mixins/rbValidator";
import * as Validators from "@/utils/validators";
import * as FormFieldValidators from "@/utils/form-field-validators";
import commonMixin from "@/mixins/commonMixin";
import formUpdateMixin from "@/mixins/formUpdateMixin";

// import {
//   productComputed,
//   productMethods,
//   productMutations
// } from "@/state/helpers";

var validations = {
  "item.firstname": FormFieldValidators.firstname,
  "item.lastname": FormFieldValidators.lastname,
  "item.email": FormFieldValidators.emailAddress,
  "item.phoneNumber": FormFieldValidators.phone,
  "item.comment": FormFieldValidators.comment_message
};
export default {
  name: "ContactUs",
  mixins: [formUpdateMixin, commonMixin, rbValidator],
  props: [],
  components: {
    Tooltip,
    Textbox,
    Textarea
  },
  data() {
    return {
      key: "value",
      loaded: false,
      page: null,
      sendSuccessful: false,
      validations: validations,
      submitMessage: "",
      submitErrors: [],
      item: {
        firstname: "",
        lastname: "",
        email: "",
        phoneNumber: "",
        comment: ""
      }
    };
  },
  methods: {
    UPDATE_FIELD(key, value) {
      this.setFieldValue(this.item, key, value);
    },
    // async getById() {
    //   var response = await UserPageService.read(this.id);
    //   this.page = response.data;
    //   this.loaded = true;
    // },
    validateContactForm(event) {
      event.preventDefault(event);
      this.validate("contact-form", this.validations);

      if (this.errors.length === 0) {
        this.canProceed = true;
        //this.$router.push('/my-account');
        this.processSubmit();

        return;
      }

      this.canProceed = false;
      this.scrollToTop("contact-form");
    },
    async processSubmit() {
      var response = await UserService.sendContactForm(
        JSON.parse(JSON.stringify(this.item))
      );
      if (response.success) {
        this.submitMessage = "";
        this.sendSuccessful = true;
        //this.reset(null);
      } else {
        this.submitErrors = response.data;
        this.submitMessage = response.message;
        this.sendSuccessful = false;
      }
    }
  },
  created() {
    setTimeout(() => {
      this.init("contact-form", this.validations);
      this.scrollToTop("contact-form");
    }, 400);
  },
  mounted() {}
};
</script>

<style scoped>
</style>